import React from 'react'

import CgtraderLogo from 'images/cgtrader_RGB_white.svg'

import { Divider } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import FooterPresentationBrands from './FooterPresentationBrands'

function FooterPresentation() {
  return (
    <section
      className="footer-presentation"
      aria-label="CGTrader brands overview"
    >
      <div className="footer-presentation__primary">
        <img
          className="footer-presentation__logo"
          src={CgtraderLogo}
          alt="CGTrader"
          width="180"
          height="40"
          loading="lazy"
        />
        <p className="footer-presentation__tagline">
          The world&apos;s largest 3D model marketplace.
        </p>
      </div>

      <Divider customClass="footer-presentation__divider" />

      <FooterPresentationBrands className="footer-presentation__brands--desktop" />
    </section>
  )
}

export default FooterPresentation
